// EN ESTE FICHERO DEBO ALMACENAR TODOS LOS HELPERS QUE CAMBIEN EL FORMATO DE LOS DATOS

//QUITAR LETRA "T" DE LAS FECHAS 
export const dateFormat = (v) =>
  (typeof v === 'string' && v.length > 10 && v[10] === 'T') ? v.replace('T', ' ') : v;